import { Component, OnInit, EventEmitter, AfterViewInit, AfterContentInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//
// Library Code
//
import * as Library from '../../../../lib/core/library/index';
import { uniqBy, isNil } from 'lodash';
import { DealerOption } from '../../../../lib/angular/model/dealer/dealer-option';
import { Action } from '../../../../lib/core/common/action';
import { Vehicle } from '../../../../lib/angular/model/vehicle/vehicle';
import { DDMenuEnableDisableService } from '../../../shared/service/common/dd-menu-enable-disable.service';
import {
  MenuActionSetActive
} from '../../../store/actions/menu.action';

import {
  SetSharedDataAction
} from '../../../store/actions/shared-data.action';


//
// Store
//
import { Store } from '@ngrx/store';
import { environment } from '../../../../environments/environment.prod';
import { IAppState, SharedDataStore, DealerOptionStore } from '../../../store/index';
//
// Services
//
import { ddDealerOptionService } from '../../../shared/service/common/dd-dealer-option.service';
import { DealerOptionActionLoad } from 'src/app/store/actions/dealer-option.action';
import { DealerDetailService } from '../../../services/api/dealer-detail.service';
import { OmnitureTags } from 'src/app/shared/omnitureTags';
//
// Accessory Map
//
type IDealerOptionMap = Map<string, DealerOption[]>;

@Component({
  providers: [OmnitureTags],
  selector: 'dd-v-spec-dealer-options',
  templateUrl: './v-spec-dealer-options.html',
  styleUrls: ['./v-spec-dealer-options.scss']
})

export class VSpecDealerOption implements OnInit, AfterContentInit, AfterViewInit, OnDestroy {
  //
  // Public
  //
  public dealerOptions: DealerOption[];
  public handleAccessoryEvent: any;
  public dealerOption: DealerOption;
  public carousel: any;
  public vehicle: Vehicle;
  public shared: any;
  public dialogActions: Action[];
  public cardActions: Action[];
  dealerDetails: any;
  dealerCd: string;
  //
  // Private
  //
  private _subscription: any;
  //
  // onCategory
  //
  public onCategory($event: MouseEvent, category: any) {
    if (Library.isDefined(category)) {
      this.carousel['categories'].forEach(
        cat => (cat.active = cat.label === category.label)
      );
      //
      // Filter Accessories
      //
      this._filterDealerOptions(category);
    }
  }

  ngAfterContentInit() {
    //
    // Listen for Dealer Options
    //
    this._store.select(DealerOptionStore).subscribe(data => {
      if (data.hasItems) {
        //
        // Load ALL Accessories
        // ::SDL
        // this.dealerOptions = uniqBy(data.items.map(dealerOption => {
        //   dealerOption.onClick = this._onClickDealerOption.bind(this);
        //   return dealerOption;
        // }), (o) => {
        //   if (!Library.isNullOrUndefined(o.productId) && !Library.isNullOrUndefined(o.subcategoryId)) {
        //     return `${o.productId}${o.subcategoryId}`;
        //   } else {
        //     return o.uid;
        //   }
        // });

        this.dealerOptions = [];
        data.items.map(dealerOption => {
          if (!Library.isNullOrUndefined(dealerOption.productId)
            && !Library.isNullOrUndefined(dealerOption.subcategoryId)) {
            const len = this.dealerOptions.filter(f =>
              !Library.isNullOrUndefined(f.productId)
              && !Library.isNullOrUndefined(f.subcategoryId)
              && f.productId === dealerOption.productId
              && f.subcategoryId === dealerOption.subcategoryId).length;
            if (len === 0) {
              dealerOption.onClick = this._onClickDealerOption.bind(this);
              this.dealerOptions.push(dealerOption);
            }
          } else {
            dealerOption.onClick = this._onClickDealerOption.bind(this);
            this.dealerOptions.push(dealerOption);
          }
        });
        //
        // Give a summary of Categories & Counts
        //
        this.carousel['categories'] = this._categorizeDealerOptions();
      }
    });
  }
  ngAfterViewInit() {

  }
  //
  // OnInit
  //
  ngOnInit() {
    //
    // Get access to the parent data
    //
    this._route.parent.data.subscribe((params: any) => {
      //
      // Listen for Shared Data
      //
      this._store.select(SharedDataStore).subscribe(data => {
        this.shared = Object.assign({}, data, {
          vehicleDetails: data.vehicleDetails,
          currentVin: data.vehicleDetails.vin
        });

        this.vehicle = data.vehicleDetails;

        this.getDealerDetails();
      });

      //
      // Save Shared Data
      //
      this._store.dispatch(new SetSharedDataAction(this.shared));

      this._ddMenuEnableDisableService.loadFeatureConfigData(this.vehicle);
      this._ddMenuEnableDisableService.loadProtectionProducts(this.shared);
      this._store.dispatch(new MenuActionSetActive(<any>{ label: 'Accessories' }));
    });

    this.route.parent.params.subscribe(params => {
      this.dealerCd = params['dealerCd'];
      });
  }

  getDealerDetails() {
    if (isNil(this.shared.dealerDetails)) {
      let dealerCd = this.dealerCd ? this.dealerCd : this.vehicle.dealerCd;
      if (!isNil(this.vehicle) && !isNil(dealerCd)) {
        this.dealerDetailService.getDealerDetails(dealerCd, 'filterOnly', 'full', 'JSON', environment.DIS_API_KEY)
          .subscribe((res => {
            this.dealerDetails = this.dealerDetailService.getFormattedDealerDetails(res);
            // console.log(this.dealerDetails);
            this.shared.dealerDetails = this.dealerDetails;
            this._store.dispatch(new SetSharedDataAction(this.shared));
            this.omTag.fireOmnitureTag('va_aa-pageload', null, this.shared);
          }));
      }
    } else {
      this.dealerDetails = this.shared.dealerDetails;
      this.omTag.fireOmnitureTag('va_aa-pageload', null, this.shared);
    }

  }

  //
  // ngOnDestroy
  //
  ngOnDestroy() {
    if (Library.isDefined(this._subscription)) {
      this._subscription.unsubscribe();
    }
  }

  //
  // _onClickDealerOption()
  //
  private _onClickDealerOption(obj: any) {

    const uid = obj.uid;
    let cardIndex = this.dealerOptions.findIndex(card => card.uid === uid);
    this.dealerOption = this.dealerOptions.find(card => card.uid === uid);
    if (Library.isObject(this.dealerOption)) {
      //
      // Call Service to get Detail Information
      //
      this._dealerOptionService
        .getByPartNumber(this.vehicle.dealerCd, this.dealerOption.partNbr)
        .subscribe(resp => {
          if (resp.hasData()) {
            this.dealerOption.description = resp.data[0].description;
            this.dealerOption.disclaimer = resp.data[0].disclaimer;
            this.omTag.fireOmnitureTag('va_aa-link', {url:this.dealerOption.detailImgPath, href: this.dealerOption.detailImgPath, text: 'view_details', trigger: 'aa-link', listIndex: cardIndex + 1, part: this.dealerOption}, this.shared);
            this.omTag.fireOmnitureTag('va_aa-subpageload', {url:'', href: '', text: '', trigger: '', listIndex: '', part: this.dealerOption}, this.shared);
            if (Library.isDefined(this.handleAccessoryEvent)) {
              this.handleAccessoryEvent.onClick.emit(obj);
            }
          }
        });
    }
  }

  private _categorizeDealerOptions() {
    const categories = [];
    this.dealerOptions.forEach(dealerOption => {
      const idx = categories.findIndex(
        cat => cat['label'] === dealerOption.category
      );
      if (idx === -1) {
        categories.push({
          label: dealerOption.category,
          count: 1,
          active: false
        });
      } else {
        categories[idx].count++;
      }
    });

    categories.unshift({
      label: 'All',
      count: categories.reduce((a, b) => a.count + b.count),
      active: true
    });

    return categories;
  }

  //
  // Filter Dealer Options
  //
  private _filterDealerOptions(category) {
    this.dealerOptions.forEach(dealerOption => {
      dealerOption.hidden = !(
        category.label === 'All' || dealerOption.category === category.label
      );
    });
  }

  //
  // Constructor
  //
  constructor(
    private _store: Store<IAppState>,
    private _dealerOptionService: ddDealerOptionService,
    private _ddMenuEnableDisableService: DDMenuEnableDisableService,
    private _route: ActivatedRoute,
    private dealerDetailService: DealerDetailService,
    public omTag: OmnitureTags,
    public route: ActivatedRoute
  ) {
    //
    // Load Accessories
    //
    this._store.dispatch(new DealerOptionActionLoad());

    (this.handleAccessoryEvent = {
      onClick: new EventEmitter<any>(),
      hidden: false
    }),
      (this.dialogActions = null);
    this.dealerOption = new DealerOption();
    this.dealerOptions = [];
    this.vehicle = new Vehicle();
    this.carousel = {
      categories: [],
      style: {
        maxWidth: '1200px'
      }
    };
    this.cardActions = [new Action({
      label: 'View Details',
      style: {
        color: 'black'
      },
      onClick: this._onClickDealerOption.bind(this)
    })];
  }
}
